export const SYSTEM_CONFIGURATION = 'SYSTEM_CONFIGURATION';
